import axios from 'axios';
import store from '../store';
import { notify } from 'app/components';
import { generateGuestToken, refreshSessionToken } from '../routes/login/api';
import { TOKEN_EXPIRY_MSGS } from './constants';

let apiRetries = 0;
let refreshTokenPromise = null;

export const apiInstance = axios.create({
  baseURL: process.env.appConfig.API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const request = async (url, method = 'get', params = {}) => {
  const {
    success,
    failure,
    id,
    headers,
    ...restOfRequestConfig
  } = params;

  try {
    if (id) store.dispatch({ type: 'APP:ACTIVE_REQUEST:APPEND', data: id });

    const requestHeaders = {
      'Content-Type': 'application/json',
      'x-auth-token': localStorage.getItem('tmt-sessionToken') || localStorage.getItem('tmt-guestToken'),
      ...headers,
    };

    const response = await apiInstance.request({
      url,
      method,
      headers: requestHeaders,
      ...restOfRequestConfig,
    });

    if (id) store.dispatch({ type: 'APP:ACTIVE_REQUEST:REMOVE', data: id });

    if (success?.callback) {
      success.callback(response.data);
    }

    if (success?.showNotifier) notify('success', response.data?.message || success?.message || 'Success!', success?.notifierProps || {});
    return response;
  } catch (error) {
    console.log(error);
    if (id) store.dispatch({ type: 'APP:ACTIVE_REQUEST:REMOVE', data: id });

    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      if (error.response.status === 401) {
        console.log(error);
        if (TOKEN_EXPIRY_MSGS.includes(error?.response?.data?.message)) {
          if (apiRetries >= 3) {
            apiRetries = 0;
            notify('error', 'Unauthorized');
            store.dispatch({ type: 'APP:REMOVE_JWT_TOKEN' });
            generateGuestToken();
            return;
          } else {
            apiRetries += 1;
            if (localStorage?.getItem('tmt-refreshToken')) {
              const appState = store.getState().app;
              let response;
              if (appState?.activeRequests?.includes('refresh-token') && refreshTokenPromise) {
                response = await refreshTokenPromise;
              } else {
                refreshTokenPromise = refreshSessionToken();
                response = await refreshTokenPromise;
              }

              if ([200, 201].includes(response?.data?.code)) {
                request(url, method, params);
              } else {
                await generateGuestToken();
                request(url, method, params);
              }
              return;
            } else {
              await generateGuestToken();
              request(url, method, params);
              return;
            }
          }
        } else {
          // notify('error', 'Unauthorized');
          store.dispatch({ type: 'APP:REMOVE_JWT_TOKEN' });
        }
      } else {
        if (failure?.callback) failure.callback(error.response.data);

        if (failure?.showNotifier) notify('error', error?.response?.data?.message || failure?.message || 'Something went wrong!', failure?.notifierProps || {});
      }
    } else {
      if (failure?.callback) failure.callback(error || {});
      notify('error', 'Something went wrong!');
    }
  }
};

const get = (url, options = {}) => request(url, 'get', options);

const post = (url, payload, options = {}) => request(url, 'post', { data: payload, ...options });

const put = (url, payload, options = {}) => request(url, 'put', { data: payload, ...options });

const patch = (url, payload, options = {}) => request(url, 'patch', { data: payload, ...options });

const drop = (url, options = {}) => request(url, 'delete', options);

export default {
  request,
  get,
  post,
  put,
  patch,
  delete: drop,
};

